import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import type { CatalogTundish } from "../models/CatalogTundish";

export const getCatalogTundishes = async () => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [{ name: "IncludeInactives", value: true }];

  return await apiService.callV2("[CAS].[GetTundishes]", parameters);
};
export const upsertCatalogTundish = async (Tundish: CatalogTundish) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [
    { name: "TundishId", value: Tundish.TundishId },
    { name: "TundishName", value: Tundish.TundishName },
    { name: "Enabled", value: Tundish.Enabled },
  ];

  return await apiService.callV2("[CAS].[UpsertTundish]", parameters);
};

export const deleteCatalogTundish = async (TundishId: number | null) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [{ name: "TundishId", value: TundishId }];

  return await apiService.callV2("[CAS].[DeleteTundish]", parameters);
};
